module.exports = __webpack_public_path__ + "img/paddie-404.ba3953d.png";